import { Globe } from "@phosphor-icons/react";

/* ============================================================================
 * CountryBreakdown — geographic distribution of installs from Apple.
 * ==========================================================================*/
const COUNTRY_NAMES = {
  US: "United States", CA: "Canada", GB: "United Kingdom", AU: "Australia",
  DE: "Germany", FR: "France", ES: "Spain", IT: "Italy", NL: "Netherlands",
  IE: "Ireland", MX: "Mexico", BR: "Brazil", IN: "India", PH: "Philippines",
  JP: "Japan", KR: "South Korea", CN: "China", HK: "Hong Kong", SG: "Singapore",
  NZ: "New Zealand", ZA: "South Africa", AE: "UAE", SA: "Saudi Arabia",
  SE: "Sweden", NO: "Norway", DK: "Denmark", FI: "Finland", CH: "Switzerland",
  AT: "Austria", BE: "Belgium", PL: "Poland", PT: "Portugal", GR: "Greece",
};
const countryEmoji = (code) => {
  if (!code || code.length !== 2 || code === "??") return "🏳";
  return code
    .toUpperCase()
    .split("")
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join("");
};

export function CountryBreakdown({ byCountry }) {
  const rows = (byCountry || []).slice(0, 15);
  const total = rows.reduce((s, r) => s + r.count, 0);

  return (
    <section
      className="border border-white/10 bg-[#0a0a0a] p-6"
      data-testid="admin-countries"
    >
      <div className="flex items-baseline justify-between mb-5">
        <div className="flex items-center gap-3">
          <Globe size={18} weight="duotone" className="text-[#FF2A2A]" />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-1">
              // installs by country
            </div>
            <h3 className="font-display text-xl font-extrabold tracking-tight">
              Where they downloaded
            </h3>
          </div>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/45">
          all-time · from apple
        </span>
      </div>

      {rows.length === 0 ? (
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/30">
          no country data yet · sync from apple first
        </p>
      ) : (
        <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
          {rows.map((r) => {
            const pct = total > 0 ? Math.round((r.count / total) * 100) : 0;
            return (
              <li key={r.country} data-testid={`country-${r.country}`}>
                <div className="flex items-baseline justify-between mb-1.5 gap-2">
                  <span className="text-sm text-white/85 flex items-center gap-2 min-w-0">
                    <span className="text-base leading-none shrink-0">{countryEmoji(r.country)}</span>
                    <span className="truncate">
                      {COUNTRY_NAMES[r.country] || r.country}
                    </span>
                  </span>
                  <span className="font-mono text-xs text-white/60 shrink-0">
                    {r.count} <span className="text-white/35">· {pct}%</span>
                  </span>
                </div>
                <div className="h-1.5 bg-white/5 overflow-hidden">
                  <div className="h-full bg-[#FF2A2A]" style={{ width: `${pct}%` }} />
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
